/* eslint-disable no-shadow */
import React, { Fragment, Component, ReactNode } from "react";
import { HashRouter as Router } from "react-router-dom";
import ActionBar from "../shared/general/ActionBar";
import Tabs from "./Tabs";

interface IEmployerAnalyticsProps {
  currencySymbol: string;
}

export class EmployerAnalytics extends Component<IEmployerAnalyticsProps> {
  render(): ReactNode {
    const { currencySymbol } = this.props;

    return (
      <Fragment>
        <ActionBar
          title="insights"
          mobileTitle="insights"
          childCompanyFilterTitleSuffix="Insights"
        />
        <Router>
          <Tabs currencySymbol={currencySymbol} />
        </Router>
      </Fragment>
    );
  }
}

export default EmployerAnalytics;
